import { ConstantsType } from '../typings'
import {
  BRAND_LIST,
  DistanceUnit,
  CountryLanguageSwitcher,
  Countries,
  Languages,
} from 'typings'

const DefaultConfig: Partial<ConstantsType> = {
  LANGUAGES: {
    EN: 'en',
  },
  RESULTS_PER_PAGE: 5,
  AREA_TRANSLATION_KEY: 'text_storesearch_byprefecture',
  SHOW_TIME_IN_MILITARY: false,
  AM_FORMAT: 'am',
  PM_FORMAT: 'pm',
  MAX_DISTANCE: 10,
  DISTANCE_UNIT: DistanceUnit.KM,
  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
    [BRAND_LIST.PL]: '',
  },
  MARKER_SUFFIX: {
    [BRAND_LIST.UQ]: 'g/icons/uq_location-pin.svg',
    [BRAND_LIST.PL]: 'g/icons/plst_location-pin.svg',
    [BRAND_LIST.GU]: 'g/icons/gu_location-pin_v2.svg',
  },
  LOGO_SUFFIX: {
    [BRAND_LIST.UQ]: 'g/icons/tab_uniqlo.svg',
    [BRAND_LIST.PL]: 'g/icons/logo_plst_v2.svg',
    [BRAND_LIST.GU]: 'g/icons/tab_gu_v2.svg',
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: false,
    [BRAND_LIST.PL]: false,
    [BRAND_LIST.GU]: false,
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
  },
  EU_COUNTRY_LIST: [
    { lid: 'text_uk', countryCode: 'uk' },
    { lid: 'text_fr', countryCode: 'fr' },
    { lid: 'text_de', countryCode: 'de' },
    { lid: 'text_es', countryCode: 'es' },
    { lid: 'text_it', countryCode: 'it' },
    { lid: 'text_dk', countryCode: 'dk' },
    { lid: 'text_se', countryCode: 'se' },
    { lid: 'text_be', countryCode: 'be' },
    { lid: 'text_nl', countryCode: 'nl' },
    { lid: 'text_at', countryCode: 'eu-at', defaultTo: 'de' },
    { lid: 'text_fi', countryCode: 'eu-fi', defaultTo: 'se' },
    { lid: 'text_gr', countryCode: 'eu-gr', defaultTo: 'it' },
    { lid: 'text_ie', countryCode: 'eu-ie', defaultTo: 'uk' },
    { lid: 'text_lu', countryCode: 'eu-lu' },
    { lid: 'text_pl', countryCode: 'eu-pl' },
    { lid: 'text_pt', countryCode: 'eu-pt', defaultTo: 'es' },
    { lid: 'text_si', countryCode: 'eu-si', defaultTo: 'it' },
    { lid: 'text_sk', countryCode: 'eu-sk', defaultTo: 'eu-pl' },
    { lid: 'text_lv', countryCode: 'eu-lv', defaultTo: 'se' },
    { lid: 'text_lt', countryCode: 'eu-lt', defaultTo: 'eu-pl' },
    { lid: 'text_ee', countryCode: 'eu-ee', defaultTo: 'se' },
    { lid: 'text_cz', countryCode: 'eu-cz', defaultTo: 'de' },
    { lid: 'text_hu', countryCode: 'eu-hu', defaultTo: 'de' },
    { lid: 'text_ro', countryCode: 'eu-ro', defaultTo: 'eu-pl' },
    { lid: 'text_bg', countryCode: 'eu-bg', defaultTo: 'it' },
    { lid: 'text_hr', countryCode: 'eu-hr', defaultTo: 'it' },
  ],
  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: false,
    [BRAND_LIST.PL]: false,
    [BRAND_LIST.GU]: false,
  },
  PARKING_FILTER: {
    WHEELCHAIR_ACCESSIBLE_PARKING: {
      [BRAND_LIST.UQ]: false,
      [BRAND_LIST.PL]: false,
      [BRAND_LIST.GU]: false,
    },
  },
  SHOW_STORE_SERVICE_FILTER: {
    [BRAND_LIST.UQ]: false,
    [BRAND_LIST.PL]: false,
    [BRAND_LIST.GU]: false,
  },
  LANGUAGE_OPTIONS: {},
}

export default DefaultConfig
